import type { MetricsDateRange } from "@/core/dashboard/entities/MetricsDateRange";
import type { CommercialCustomersFilters } from "@/core/dashboard/entities/CommercialCustomer";

// Relative path: HttpClient prepends the backend base URL (which already
// includes the `/api/v1` context-path), matching the other endpoint modules.
const DASHBOARD_BASE = `/dashboard`;

/**
 * Serializes a flat record into a query string, skipping undefined/null/empty
 * values. Returns "" when no param is set (so callers can append unconditionally).
 */
function buildQueryString(
  params: Record<string, string | number | boolean | undefined | null>,
): string {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.set(key, String(value));
    }
  });
  const qs = search.toString();
  return qs ? `?${qs}` : "";
}

function rangeQuery(range?: MetricsDateRange): string {
  return buildQueryString({
    dateFrom: range?.dateFrom,
    dateTo: range?.dateTo,
  });
}

/** KPI-P1 — Chargé d'Affaires. */
export const getP1MetricsUrl = (range?: MetricsDateRange): string =>
  `${DASHBOARD_BASE}/commercial/p1/metrics${rangeQuery(range)}`;

/** KPI-P2 — Directeur d'Agence. */
export const getP2MetricsUrl = (range?: MetricsDateRange): string =>
  `${DASHBOARD_BASE}/agence/p2/metrics${rangeQuery(range)}`;

/** KPI-P3 — Analyste AML/CFT. */
export const getP3MetricsUrl = (range?: MetricsDateRange): string =>
  `${DASHBOARD_BASE}/compliance/p3/metrics${rangeQuery(range)}`;

/** KPI-P4 — Responsable Conformité. */
export const getP4MetricsUrl = (range?: MetricsDateRange): string =>
  `${DASHBOARD_BASE}/conformite/p4/metrics${rangeQuery(range)}`;

/** P1 drill-down — commercial customers list (PaginatedResponse). */
export const getCommercialCustomersUrl = (
  filters: CommercialCustomersFilters,
): string =>
  `${DASHBOARD_BASE}/commercial/customers${buildQueryString({
    filterValue: filters.filterValue,
    customerType: filters.customerType,
    status: filters.status,
    kycStatus: filters.kycStatus,
    conversionStatus: filters.conversionStatus,
    createdBy: filters.createdBy,
    period: filters.period,
    dateFrom: filters.dateFrom,
    dateTo: filters.dateTo,
    page: filters.page,
    size: filters.size,
  })}`;
